/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyCRKqbCQDz68HzHs8Q556AT-I8xrv8ma9k",
    authDomain: "fg-security.firebaseapp.com",
    databaseURL: "https://fg-security.firebaseio.com",
    projectId: "fg-security",
    storageBucket: "fg-security.appspot.com",
    messagingSenderId: "774799030369",
    appId: "1:774799030369:web:8e04259292bd60eccad220",
    measurementId: "G-7FK687515G"
  },
  infoAccount: "ghaucha@hotmail.be",
  infoAccountId: "DFmId27KdsRptLsE3185UZO6Z1F2",
  infoAccount2: "mahmoud.karoui2015@gmail.com"
};
